'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bignumber = require('bignumber.js');

var _constants = require('../constants');

var _isNumber = require('./isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Round an Eth/Token amount to specified number of decimal places.
 *
 * @param {String|Number} value
 * @param {Number?} decimals
 * @returns {String}
 */
exports.default = function (value) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.DEFAULT_ETH_DECIMALS;

  if ((0, _isNumber2.default)(value)) {
    var BigNum = _bignumber.BigNumber.clone({
      FORMAT: {
        decimalSeparator: '.',
        groupSeparator: '',
        groupSize: 0,
        secondaryGroupSize: 0,
        fractionGroupSeparator: ' ',
        fractionGroupSize: 0
      }
    });
    var number = BigNum(value);
    // Round/truncate if number of decimals is > than desired.
    if (number.dp() > decimals) {
      return number.toFormat(decimals);
    }
    return value.toString();
  }
  throw new Error('Value is not a valid Number');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/utilities/roundEth.js
// module id = 450
// module chunks = 0